import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import Table from '../../../components/layout/Table'
import Modal from '../../../components/popup/Modal'
import { mapHanhDong } from '../../../constant/hanhDongChinhSua'
import chinhSuaVanBangProcessor from '../../../processor/chinhSuaVanBangProcessor'
import { dateToDDMMYY } from '../../../utils/date'
import ViewVanBang from '../ViewVanBang'

const disabled = [
  'hoTen',
  'cccd',
  'gioiTinh',
  'ngaySinh',
  'noiSinh',
  'danToc',
  'truongId',
  'hanhKiem',
  'hocLuc',
  'ketQua',
  'xepLoai',
  'heDaoTaoId',
  'hinhThucDaoTaoId',
  'donViDangKyDuThiId',
  'hoiDongId',
  'soHieu',
  'soCapBang',
  'khoaThiId',
  'ngayKy',
  'nguoiKy',
  'ngayCapBang',
  'ghiChu',
]

export default function LichSuDieuChinhMotVanBang(props) {
  const { visible, toggle, id } = props
  const [datas, setDatas] = useState([])
  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button
        label="Huỷ"
        className="p-button-secondary mr-2"
        onClick={() => {
          if (toggle) toggle()
        }}
      />
    </div>
  )
  useEffect(async () => {
    if (id) {
      const rs = await chinhSuaVanBangProcessor.getHistory(id)
      if (rs.isSuccess) {
        setDatas(rs.data)
      }
    }
  }, [id])
  const column = [
    { value: 'hoTen', name: 'Họ tên', render: (data) => data.vanBang.hoTen },
    { value: 'soHieu', name: 'Số hiệu', render: (data) => data.vanBang.soHieu },
    { value: 'soCapBang', name: 'Số cấp bằng', render: (data) => data.vanBang.soCapBang },
    { value: 'type', name: 'Hành động', render: (data) => mapHanhDong(data.type, data) },
    { value: 'nguoiTao', name: 'Người tạo', render: (data) => data.nguoiTao.fullname },
    { value: 'noiDung', name: 'Nội dung' },
    {
      value: 'ngayTao',
      name: 'Ngày thao tác',
      render: (data) => dateToDDMMYY(new Date(data.ngayTao)),
    },
    {
      render: (data) => <ViewVanBang data={data.vanBang} disabled={disabled} disabledAll />,
    },
  ]

  return (
    <>
      <Modal visible={visible} toggle={toggle} footer={footer} width="80%">
        <Table data={datas} column={column} />
      </Modal>
    </>
  )
}
